/* Mit Motiv · de nye produkter (18/10-2026, planen “Produkternes plads i webshoppen”)
   1) Stilvælgeren (snippets/mm-motiv-stil): viser den valgte stils navn og husker den (sessionStorage), så den er valgt
      igen på næste produkt. ?stil=Cartoon i adressen vælger stilen.
   2) Familievælgeren (snippets/mm-motiv-familie): stilen følger med i adressen, og kundens foto følger med til næste
      side (gemmes kun i browserens egen database, IndexedDB — intet sendes, før kunden lægger i kurven).
   Alt er “bedste forsøg”: virker noget ikke i en browser, fungerer siden som en almindelig produktside. */
(() => {
  if (window.MMMotiv) return;
  window.MMMotiv = true;
  const d = document;
  const NOEGLE = 'mm-motiv-stil';
  const lagr = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* privat vindue */ } },
  };

  // ---------------------------------------------------------------- stil
  const visNavn = (input) => {
    const box = input.closest('[data-mm-stil]');
    const navn = box && box.querySelector('[data-mm-stil-navn]');
    if (navn) navn.textContent = input.dataset.vis || input.value;
  };
  const vaelgStil = (vaerdi) => {
    if (!vaerdi) return false;
    const input = Array.from(d.querySelectorAll('[data-mm-stil] input[type="radio"]')).find((x) => x.value.toLowerCase() === vaerdi.toLowerCase());
    if (!input) return false;
    input.checked = true;
    visNavn(input);
    return true;
  };
  d.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-mm-stil] input[type="radio"]')) {
      visNavn(t);
      lagr.set(NOEGLE, t.value);
    }
  });

  // ---------------------------------------------------------------- foto (IndexedDB)
  const DB = 'mm-motiv';
  const aabn = () => new Promise((ok, fejl) => {
    if (!window.indexedDB) { fejl(new Error('ingen IndexedDB')); return; }
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore('foto');
    r.onsuccess = () => ok(r.result);
    r.onerror = () => fejl(r.error);
  });
  const gemFotos = async (filer) => {
    try {
      const db = await aabn();
      const liste = Array.from(filer || []).slice(0, 2).map((f) => ({ navn: f.name, type: f.type, blob: f }));
      await new Promise((ok) => { const tx = db.transaction('foto', 'readwrite'); tx.objectStore('foto').put(liste, 'sidste'); tx.oncomplete = ok; tx.onerror = ok; });
    } catch (e) { /* ignorer */ }
  };
  const hentFotos = async () => {
    try {
      const db = await aabn();
      return await new Promise((ok) => { const r = db.transaction('foto').objectStore('foto').get('sidste'); r.onsuccess = () => ok(r.result || []); r.onerror = () => ok([]); });
    } catch (e) { return []; }
  };
  d.addEventListener('change', (e) => {
    const t = e.target;
    if (t && t.matches && t.matches('[data-cr-file]') && t.files && t.files.length && !t.dataset.mmGendannet) gemFotos(t.files);
  });

  // ---------------------------------------------------------------- familievælgeren
  d.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-mm-fam]');
    if (!a || a.getAttribute('aria-current') === 'page') return;
    try {
      const url = new URL(a.href, window.location.href);
      const valgt = d.querySelector('[data-mm-stil] input[type="radio"]:checked');
      if (valgt) url.searchParams.set('stil', valgt.value);
      const fil = d.querySelector('[data-cr-file]');
      if (fil && fil.files && fil.files.length) url.searchParams.set('foto', '1');
      a.href = url.toString();
    } catch (err) { /* almindeligt link */ }
  });

  let params = null;
  try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
  const stilStart = () => {
    if (!(params && vaelgStil(params.get('stil')))) vaelgStil(lagr.get(NOEGLE));
  };
  // fotoet lægges først ind, når upload-feltets eget script (mm-craft-upload.js, indlæses senere på siden) er klar
  const fotoStart = async () => {
    if (params && params.get('foto') === '1') {
      const fil = d.querySelector('[data-cr-file]');
      if (fil && !(fil.files && fil.files.length) && window.DataTransfer) {
        const fotos = await hentFotos();
        if (fotos.length) {
          try {
            const dt = new DataTransfer();
            fotos.forEach((x) => dt.items.add(new File([x.blob], x.navn, { type: x.type })));
            fil.dataset.mmGendannet = '1';
            fil.files = dt.files;
            fil.dispatchEvent(new Event('change', { bubbles: true }));
            delete fil.dataset.mmGendannet;
          } catch (e) { /* kunden vælger fotoet igen */ }
        }
      }
      try { params.delete('foto'); const ny = window.location.pathname + (params.toString() ? '?' + params.toString() : '') + window.location.hash; window.history.replaceState(null, '', ny); } catch (e) { /* ignorer */ }
    }
  };
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', stilStart);
  else stilStart();
  if (d.readyState === 'complete') fotoStart();
  else window.addEventListener('load', fotoStart);
})();
